export default function getEnvironment() {
  let env = 'development'
  const currentURL = process.env.NEXT_PUBLIC_FRONTEND_URL
  const currentENV = process.env.NODE_ENV

  if (
    currentURL === 'https://www.bangkokhospital.com' &&
    currentENV === 'production'
  ) {
    env = 'production'
  } else if (currentURL.includes('staging') && currentENV === 'production') {
    env = 'staging'
  } else {
    env = 'development'
  }

  return env
}
